import { addRegulatoryRequirement, editRegulatoryRequirement, review } from "./actions.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";

const issmReview = review("ISMM");
const auditableReview = review("Auditable");
const safetyManagerReview = review("SafetyManager");
const easaReview = review("EASA");

export default [{
    "path": "/SafetyManagement/InformationSafetyManager/RegulatoryRequirements",
    "component": { ...ItemListView },
    "name": "Regulatory Requirements",
    "meta": {
        "app": "SafetyManagement",
        "sideNav": true,
        "appSwitcher": false,
        "sideNavSection": "Information Security Management",
        "name": "Regulatory Requirements",
        "tableSettings": "RegulatoryRequirements",
        "dataPath": "SafetyManagement/InformationSafetyManager/RegulatoryRequirements",
        "selectionRoute": "SafetyManagement/InformationSafetyManager/RegulatoryRequirements/{ID}",
        "menuActions": [{
            "label": "Add Regulatory Requirement",
            "action": addRegulatoryRequirement
        }]
    }
}, {
    "path": "/SafetyManagement/InformationSafetyManager/RegulatoryRequirements/:id",
    "component": ItemView,
    "name": "Regulatory Requirement",
    "meta": {
        "app": "SafetyManagement",
        "name": "Regulatory Requirement",
        "dataPath": "SafetyManagement/InformationSafetyManager/RegulatoryRequirements",
        "title": (item) => `Regulatory Requirement: ${item.RegulatoryRequirement}`,
        "dataFields": [{
            "label": "Element",
            "key": "Element",
            "grow": true,
            "class": "md:col-span-3"
        }, {
            "label": "Regulatory Requirement",
            "key": "RegulatoryRequirement"
        }, {
            "label": "Regulatory Requirement Number",
            "key": "RegulatoryRequirementNumber"
        },  {
            "label": "ISMM",
            "key": "ISMM"
        }, {
            "label": "Auditable",
            "key": "Auditable"
        }, {
            "label": "Safety Manager",
            "key": "SafetyManager"
        }, {
            "label": "EASA",
            "key": "EASA"
        }, {
            "label": "Date Added",
            "key": "Date.Added",
            "type": "date"
        }, {
            "label": "Date Updated",
            "key": "Date.Updated",
            "type": "date"
        }, {
            "label": "Review Comments",
            "type": "sectionHeader",
            "class": "md:col-span-3 border-t border-t-1",
            "break": true
        }, 
        {
            "label": "ISMM Review Date",
            "key": "Date.ISMM",
            "type": "date"
        }, {
            "label": "Auditable Review Date",
            "key": "Date.Auditable",
            "type": "date"
        }, {
            "label": "Safety Manager Review Date",
            "key": "Date.SafetyManager",
            "type": "date"
        }, {
            "label": "EASA Review Date",
            "key": "Date.EASA",
            "type": "date"
        }, {
            "label": "ISMM Review Comments",
            "key": "ISMMComments",
            "type": "richtext",
            "class": "md:col-span-3",
            "grow": true
        }, {
            "label": "Auditable Review Comments",
            "key": "AuditableComments",
            "type": "text",
            "class": "md:col-span-3",
            "grow": true
        }, {
            "label": "Safety Manager Review Comments",
            "key": "SafetyManagerComments",
            "type": "text",
            "class": "md:col-span-3",
            "grow": true
        }, {
            "label": "EASA Review Comments",
            "key": "EASAComments",
            "type": "text",
            "class": "md:col-span-3",
            "grow": true
        }],
  
        "menuActions": [{
            "label": "Edit Regulatory Requirement",
            "action": editRegulatoryRequirement
        }, {
            "label": "ISMM Review",
            "action": issmReview
        }, {
            "label": "Auditable Review",
            "action": auditableReview
        }, {
            "label": "Safety Manager Review",
            "action": safetyManagerReview
        }, {
            "label": "EASA Review",
            "action": easaReview
        }]
    }
}];

